import { useQuery } from "@tanstack/react-query";
import { api } from "@utils/api";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { onboardingQKeys } from "./queryKeys";

export const useGetMySession = (enabled: boolean = true) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: onboardingQKeys.session(),
    queryFn: () => api.get(`onboarding/session/me`),
    select: (res: any) => res.data,
    enabled,
    retry: false,
    onError: (res: any) => {
      console.error("[From Get My Session]", res);
      handleErrors(res, "query");
    },
  });
};
